import { Box, Flex, Text } from '@chakra-ui/react';
import Editor from '@monaco-editor/react';
import { FormikProps } from 'formik';
import React from 'react';

import { CreditAgreement } from '@finley-technologies/finley-types';

type AccruedLiabilitiesConfigProps = {
  values: CreditAgreement.Config.Reporting.Inputs.DataAccessor.AccruedLiabilitiesAccessor;
  formProps: FormikProps<CreditAgreement.Config.Reporting.Inputs.DataAccessor.Accessor>;
};
export const AccruedLiabilitiesConfig = ({
  values,
  formProps,
}: AccruedLiabilitiesConfigProps) => {
  const { parameterConfig } = values;

  return (
    <Box id="accrued-liabilities-config-container">
      <Box mb="4">
        <Flex mb="3">
          <Text>Starting Date Formula:</Text>
          <Editor
            value={parameterConfig.startDateFormula.params.formula}
            onChange={(val) =>
              formProps.setFieldValue(
                'parameterConfig.startDateFormula.params.formula',
                val,
              )
            }
            width="100%"
            theme="vs-dark"
            height="15vh"
          />
        </Flex>
        <Flex mb="3">
          <Text>Ending Date Formula:</Text>
          <Editor
            value={parameterConfig.endDateFormula.params.formula}
            onChange={(val) =>
              formProps.setFieldValue(
                'parameterConfig.endDateFormula.params.formula',
                val,
              )
            }
            width="100%"
            theme="vs-dark"
            height="15vh"
          />
        </Flex>
      </Box>
    </Box>
  );
};
